export default "__VITE_ASSET__d8rm$T4H__"